import allowedDomains from '../lists/allowedEmailsDomains.json'
export const isInvaidNamePerson = str => {
    // Check se é um nome valido com pelo menos um espaço ex: Lucas Barbosa
    return str.split(' ').length < 2 ? true : false
}

export const isNotTrim = str => {
    // Check se a string não tem espaço no inicio ou no fim
    return str.indexOf(' ') === 0 || str.lastIndexOf(' ') === str.length - 1 ? true : false
}

export const isInvalidEmail = str => {
    // Check se o email tem 1 caracter antes do @ e 1 depois / se pelo menos um dominio após o @ esta na lista de dominios comuns
    let valid = false
    let isEmail = false

    if (str.indexOf('@') > 0) {
        isEmail = true
    }
    if (isEmail) {
        allowedDomains.forEach((d) => {
            if (str.split('@')[1]?.indexOf(d) >= 1) valid = true
        })
    }

    return !valid || !isEmail ? true : false
}

export const isInvalidContentOfMask = str => {
    // Check se tem o caracter _ para saber se o inout com mask está totalmente preenchido
    return str.indexOf('_') >= 0
}
